import React from "react";
// import { Container, Image } from "semantic-ui-react";
// import noPage from "../../assets/images/404.svg";

const NotFound = () => {
  return (
    <div>
      <center>
        {/* <Image src={noPage} alt="404" /> */}
        <h1>Page Not Found</h1>
        <p>Ensure you've clicked on the right page</p>
      </center>
    </div>
  );
};

export default NotFound;
